module.exports = __webpack_public_path__ + "static/img/runBook.d0d5c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/runBook.png
// module id = p52P
// module chunks = 2